import { combineReducers, configureStore } from "@reduxjs/toolkit";
import LogRocket from "logrocket";
import {
  legacyReducer,
  SET_TIMEAXISCONTEXT_STATE,
} from "providers/GlobalStateProvider";
import customerSlice from "./customerSlice";
import retrotagSlice from "./retrotagSlice";

// https://redux-toolkit.js.org/api/other-exports#combinereducers
export const rootReducer = combineReducers({
  legacy: legacyReducer,
  customer: customerSlice,
  retrotag: retrotagSlice,
});

export type RootState = ReturnType<typeof rootReducer>;

export const store = configureStore({
  reducer: rootReducer,
  middleware: getStoreMiddleware,
});
export function getStoreMiddleware(getDefaultMiddleware) {
  // disable immutableCheck (dev only -- too slow) https://github.com/reduxjs/redux-toolkit/issues/415#issuecomment-596812076
  return getDefaultMiddleware({
    immutableCheck: false,
    serializableCheck: false,
  }).concat(
    // other middlewares go here...
    // LogRocket middleware should come last
    LogRocket.reduxMiddleware({
      // ignore actions that occur too frequently
      actionSanitizer: action => {
        if ([SET_TIMEAXISCONTEXT_STATE].includes(action.type)) {
          return null;
        }
        return action;
      },
    })
  );
}
